import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SystemSettingsService } from '@core/services/system-settings.service';
import { ModulesActivation } from 'src/app/system/models/system-settings';

export const moduleGuard: CanActivateFn = async (route) => {
    const router = inject(Router);
    const systemSettingsService = inject(SystemSettingsService);

    const moduleName = route.data['moduleName'] as keyof ModulesActivation;
    const globalSettings = await systemSettingsService.GlobalSettings();
    const isModuleEnabled = globalSettings.modulesActivation[moduleName] === true;

    if (isModuleEnabled) return true;

    router.navigate(['/']);
    return false;
};
